import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-center',
  templateUrl: './admin-center.component.html',
  styleUrls: ['./admin-center.component.scss'],
})
export class AdminCenterComponent {

  constructor() {}
}
